module.exports = __webpack_public_path__ + "static/media/washington-dc-84.7173ca1e.jpg";